import { useContext, useEffect, useState } from "react";
import { ReactComponent as eventIcon } from '../../../../icons/event.svg';
import 'react-datepicker/dist/react-datepicker.css';
import './../poFormView.scss';
import { DatepickerFieldProps } from "../../../../components/datepickerField/types/datepickerFieldProps";
import DatepickerField from "../../../../components/datepickerField/datepickerField";
import PoFormContext from "../../../../contexts/poFormContext";
import { styleFormFieldHalf } from "../../../../components/shared/stylization";
import { createConfigValidation } from "../../../../helpers/validation/validation";

const ObservationDate = () => {
    const { poForm, setPoForm } = useContext(PoFormContext);
    const [errorTipText, setErrorTipText] = useState("");
    const [reload, setReload] = useState(false);

    // Validation
    useEffect(() => {
        if (poForm.config?.check && !poForm.config.isValid) {
            var errorMsg = poForm.config?.ValidationError!["datA_OBS"]
            if (errorMsg !== '') {
                setErrorTipText(errorMsg);
                setReload(!reload);
            }
        }  
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [poForm.config?.check])
    
    const onChangeObservationDate = (event: Date) => {
        var form: any = Object.assign({}, poForm);
        if (form !== null && form.protocolAttributes) {
            event ? form.protocolAttributes.datA_OBS = event.getTime() : form.protocolAttributes.datA_OBS = null;
        }
        setPoForm(form);
    }

    // Date of observation
    var datepickerFieldPropsDateOfObservation: DatepickerFieldProps = {
        dateFormat: "yyyy-MM-dd",
        selected: poForm.protocolAttributes?.datA_OBS ? new Date(new Date(poForm.protocolAttributes?.datA_OBS).setHours(0,0,0,0)) : poForm.protocolAttributes?.datA_OBS,
        shouldCloseOnSelect: false,
        fixedHeight: true,
        inputPlaceholder: "Wybierz datę",        
        labelName: 'Data obserwacji',
        style: styleFormFieldHalf,
        configValidation: createConfigValidation("datA_OBS", true),
        additionalIcon: eventIcon,
        setValue: onChangeObservationDate,
        pristine: true,
        validationError: poForm.config?.isValid !== undefined ? !poForm.config?.isValid : false,
        tipText: errorTipText,
        reload: reload
    }

    return (
        <>
            <div>
                <h2>7. Data obserwacji</h2>
                <DatepickerField {...datepickerFieldPropsDateOfObservation}/>
            </div>
        </>
    )
}

export default ObservationDate